import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useAuth } from '../../contexts/AuthContext';
import usePatientDoc from '../../hooks/usePatientDoc';
import { PatientDoc } from '@usacsmideo/types';
import { Heading } from '../../components/Heading';
import { Menu } from 'iconoir-react';
import { useNavObjVersionUpdate } from '../../hooks/useNavObjVersionUpdate';
import { normalizePortalPath } from '../../utilities/normalizePortalPath';

export const Route = createFileRoute('/_authenticated/home')({
  component: Home,
});

function Home() {
  const { currentUser } = useAuth();
  const patientId = currentUser?.uid || '';
  const patientDocQuery = usePatientDoc(patientId);
  const patientInfo = patientDocQuery.data as PatientDoc;
  const navigate = useNavigate();

  // KEEP NAV OBJECT UP-TO-DATE (CU-17tm466h63q). One guarded CF call per stale
  // version; the server writes the reconciled navObj, so there is no client
  // write here. No chart gate on this route, as before.
  useNavObjVersionUpdate({ patientId, patientInfo, enabled: true });

  if (!patientInfo || !patientInfo?.navObj) {
    return <div>Loading...</div>;
  }

  if (patientInfo && currentUser) {
    return (
      <>
        {/* <Header patientId={patientId} /> */}
        <div className="flex flex-col items-center">
          <Heading id="welcome" textContent="Welcome!" />
          <p id="thank-you-message" className="text-xl">
            Thank your for creating your MIDEO account. You have made the first step in ensuring your wishes are heard
            even when you are unable to speak for yourself.
          </p>
          <div className="my-8 flex flex-col items-center">
            {/* TODO: Add captions track and disable warning */}
            {/* eslint-disable-next-line */}
            <video id="patient-education-video" className="w-1/3" controls>
              <source
                src="https://storage.googleapis.com/mideoid-console-public/videos/instructional/en/patientOverview.mp4"
                type="video/mp4"
              />
            </video>
          </div>
          <p className="text-xl">
            In order to make sure you are receiving the most accurate care we can provide we are going to ask you to
            complete a number of forms. We will break each of these topics into their own pages; however you will not
            see the full list in the{' '}
            <span>
              <Menu className="inline" />
            </span>{' '}
            &quot;Hamburger&quot; menu all at once. Rather, We will continue to add pages to this menu as you visit
            them. Feel free to return to any page at any point in the process. Clicking the Next button will always take
            you to the most recent page you need to complete.
          </p>
          <button
            onClick={() => {
              navigate({
                to: patientInfo.navObj.onboardingIndex
                  ? normalizePortalPath(patientInfo.navObj.onboardingIndex.portalPath)
                  : '/home',
              });
            }}
            className="m-4 rounded bg-blue-500 px-4 py-2 font-bold text-white hover:bg-blue-700"
          >
            Next
          </button>
        </div>
      </>
    );
  }
  return <div>Loading...</div>;
}
